"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountAPI = void 0;
const base_1 = require("../base");
class AccountAPI extends base_1.BaseAPI {
    /**
     * Get your account details.
     *
     * @see https://developers.themoviedb.org/3/account/get-account-details
     */
    async details(filters) {
        const path = this.getPath('/account', filters);
        return this.get(path);
    }
    /**
     * Get all of the lists created by an account. Will invlude private lists if you are the owner.
     *
     * @see https://developers.themoviedb.org/3/account/get-created-lists
     */
    async createdLists(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/lists`, filters);
        return this.get(path);
    }
    /**
     * Get the list of your favorite movies.
     *
     * @see https://developers.themoviedb.org/3/account/get-favorite-movies
     */
    async favoriteMovies(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/favorite/movies`, filters);
        return this.get(path);
    }
    /**
     * Get the list of your favorite TV shows.
     *
     * @see https://developers.themoviedb.org/3/account/get-favorite-tv-shows
     */
    async favoriteTVShows(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/favorite/tv`, filters);
        return this.get(path);
    }
    /**
     * This method allows you to mark a movie or TV show as a favorite item.
     *
     * @see https://developers.themoviedb.org/3/account/mark-as-favorite
     */
    async markAsFavorite(accountId, data, filters) {
        const path = this.getPath(`/account/${accountId}/favorite`, filters);
        return this.post(path, data);
    }
    /**
     * Get a list of all the movies you have rated.
     *
     * @see https://developers.themoviedb.org/3/account/get-rated-movies
     */
    async ratedMovies(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/rated/movies`, filters);
        return this.get(path);
    }
    /**
     * Get a list of all the TV shows you have rated.
     *
     * @see https://developers.themoviedb.org/3/account/get-rated-tv-shows
     */
    async ratedTVShows(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/rated/tv`, filters);
        return this.get(path);
    }
    /**
     * Get a list of all the TV episodes you have rated.
     *
     * @see https://developers.themoviedb.org/3/account/get-rated-tv-episodes
     */
    async ratedTVEpisodes(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/rated/tv/episodes`, filters);
        return this.get(path);
    }
    /**
     * Get a list of all the movies you have added to your watchlist.
     *
     * @see https://developers.themoviedb.org/3/account/get-movies-watchlist
     */
    async movieWatchlist(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/watchlist/movies`, filters);
        return this.get(path);
    }
    /**
     * Get a list of all the TV shows you have added to your watchlist.
     *
     * @see https://developers.themoviedb.org/3/account/get-tv-show-watchlist
     */
    async tvShowWatchlist(accountId, filters) {
        const path = this.getPath(`/account/${accountId}/watchlist/tv`, filters);
        return this.get(path);
    }
    /**
     * Add a movie or TV show to your watchlist.
     *
     * @see https://developers.themoviedb.org/3/account/add-to-watchlist
     */
    async addToWatchlist(accountId, data, filters) {
        const path = this.getPath(`/account/${accountId}/watchlist`, filters);
        return this.post(path, data);
    }
}
exports.AccountAPI = AccountAPI;
